(function () {
  if (window.__customAddonCartInit) return;
  window.__customAddonCartInit = true;

  var ADD_URL = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';

  function selectedAddonItems(form) {
    var parentInput = form.querySelector('[name="id"]');
    var parentId = parentInput ? parentInput.value : '';
    var inputs = document.querySelectorAll('.custom-addon__input[value="yes"]');
    var items = [];
    inputs.forEach(function (input) {
      if (!input.checked || input.disabled) return;
      var id = input.dataset.variantId;
      if (!id) return;
      var properties = { _addon: '1' };
      if (parentId) properties._addon_parent_id = String(parentId);
      items.push({ id: Number(id), quantity: 1, properties: properties });
    });
    return items;
  }

  function bind(form) {
    if (form.__customAddonBound) return;
    form.__customAddonBound = true;

    form.addEventListener(
      'submit',
      function (evt) {
        if (form.dataset.addonsHandled === 'true') {
          delete form.dataset.addonsHandled;
          return;
        }

        var items = selectedAddonItems(form);
        if (!items.length) return;

        evt.preventDefault();
        evt.stopImmediatePropagation();

        var submitButton = form.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
        }

        var resubmit = function () {
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          }
          form.dataset.addonsHandled = 'true';
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(submitButton || undefined);
          } else {
            form.submit();
          }
        };

        fetch(ADD_URL + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ items: items }),
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok) {
              console.error('Add-on add failed:', result.data && result.data.description);
            }
            resubmit();
          })
          .catch(function (e) {
            console.error('Add-on add failed:', e);
            resubmit();
          });
      },
      true
    );
  }

  function init() {
    document.querySelectorAll('product-form form').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
